import { render, staticRenderFns } from "./menuButton.vue?vue&type=template&id=03c15a7f&scoped=true&"
import script from "./menuButton.vue?vue&type=script&lang=js&"
export * from "./menuButton.vue?vue&type=script&lang=js&"
import style0 from "./menuButton.vue?vue&type=style&index=0&id=03c15a7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c15a7f",
  null
  
)

export default component.exports